import React from 'react'
import { string, object, array } from 'prop-types'

import InterviewImages from './component/InterviewImages'
import ArticleVideo from './component/ArticleVideo'
import ResponsiveImage from '../ResponsiveImage'
import ResponsiveMedia from '../ResponsiveMedia'
import CaptionedMedia from '@/component/Primitive/CaptionedMedia'

const typeMap = (props) => ({
  Interview: <InterviewImages {...props} />,
  Video: <ArticleVideo {...props} />
})

const ArticleImages = (props) => {
  const { contentType, images, imageRatio, src, srcSet, sizes, caption } = props

  // DO NOT SHOW IF ONLY ONE IMAGE SUPPLIED TO AN INTERVIEW
  if (images?.hero_portrait_144?.length === 1 && contentType === 'Interview')
    return null

  if (contentType === 'Company Report') return null

  return (
    typeMap(props)[contentType] || (
      <CaptionedMedia caption={caption}>
        <ResponsiveMedia ratio={imageRatio}>
          <ResponsiveImage
            loading="eager"
            alt=""
            src={src}
            srcSet={srcSet}
            sizes={sizes}
          />
        </ResponsiveMedia>
      </CaptionedMedia>
    )
  )
}

ArticleImages.propTypes = {
  contentType: string.isRequired,
  images: object,
  imageRatio: string,
  src: string,
  srcSet: object,
  sizes: array,
  caption: string
}

export default ArticleImages
